import { render, staticRenderFns } from "./CFactories.vue?vue&type=template&id=acf51592"
import script from "./CFactories.vue?vue&type=script&lang=js"
export * from "./CFactories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports